function t(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e)["catch"](function (o) {
    return setTimeout(function () {
      throw o;
    });
  });
}
export { t as microTask };